import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#074443'
    },
    secondary: {
      main: '#ff9c00'
    }
  }
});